import React from 'react';
import { Search, AlertTriangle, Flame, CalendarX, Frown, Brain, Clock, Activity } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const painPoints = [{
  icon: Search,
  title: 'No sabés qué cocinar',
  desc: 'Terminás repitiendo siempre las mismas comidas.'
}, {
  icon: AlertTriangle,
  title: 'Vivís leyendo etiquetas',
  desc: 'Y aun así tenés miedo de equivocarte.'
}, {
  icon: Flame,
  title: 'Sentís inflamación constante',
  desc: 'Aunque intentás cuidarte.'
}, {
  icon: CalendarX,
  title: 'No organizás tus comidas',
  desc: 'Y terminás comiendo cualquier cosa.'
}, {
  icon: Frown,
  title: 'Te cuesta encontrar recetas fáciles',
  desc: 'Todo parece complicado o caro.'
}, {
  icon: Brain,
  title: 'Tenés ansiedad con la comida',
  desc: 'Porque no sabés qué alimentos son realmente seguros.'
}, {
  icon: Clock,
  title: 'Comés fuera de horario',
  desc: 'Y eso empeora tu bienestar físico.'
}, {
  icon: Activity,
  title: 'Sentís cansancio o molestias digestivas',
  desc: 'Porque la alimentación no está bien organizada.'
}];
export function PainPoints() {
  return <section className="py-20 md:py-28 bg-brand-50 relative overflow-hidden" data-id="element-161">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-162">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-163">
          <FadeIn data-id="element-164">
            <h2 className="text-sm font-bold tracking-widest text-brand-600 uppercase mb-3" data-id="element-165">
              ¿TE PASA ESTO?
            </h2>
            <p className="text-3xl md:text-4xl font-serif font-bold text-brand-950" data-id="element-166">
              Si sos celíaco/a, seguramente esto te resulte familiar:
            </p>
          </FadeIn>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-167">
          {painPoints.map((point, idx) => {
          const Icon = point.icon;
          return <FadeIn key={idx} delay={idx * 0.1} className="bg-white p-6 rounded-3xl shadow-soft hover:shadow-soft-lg transition-shadow border border-brand-100" data-id="element-168">
                <div className="w-12 h-12 bg-red-50 rounded-2xl flex items-center justify-center mb-5" data-id="element-169">
                  <Icon className="w-6 h-6 text-red-400" data-id="element-170" />
                </div>
                <h3 className="text-lg font-bold text-brand-950 mb-2" data-id="element-171">
                  {point.title}
                </h3>
                <p className="text-brand-700 text-sm leading-relaxed" data-id="element-172">
                  {point.desc}
                </p>
              </FadeIn>;
        })}
        </div>

        <FadeIn delay={0.4} className="text-center" data-id="element-173">
          <p className="text-2xl md:text-3xl font-serif font-bold text-brand-800" data-id="element-174">
            ¿Cuánto tiempo más vas a seguir improvisando tu alimentación?
          </p>
        </FadeIn>
      </div>
    </section>;
}